module.exports = __webpack_public_path__ + "img/8_7.92eade07.png";